import React from "react";
import { Container } from "react-bootstrap";
import { ImUpload2 } from "react-icons/im";
import { TiSocialYoutubeCircular } from "react-icons/ti";
import { FaWallet } from "react-icons/fa";
import { motion } from "framer-motion";

const HowTo = () => {
  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 }
  };

  return (
    <div className="sell-music-howto">
      <Container>
        <motion.div 
          className="mini-title"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          variants={itemVariants}
        >HOW TO SELL</motion.div>
        <motion.h2
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.2 }}
          variants={itemVariants}
        >
          Get your music playing to 155+ streaming services and stores worldwide, and start making the money by following these 3 steps
        </motion.h2>

        <div className="howto-steps">
          {/* Dashed line 1 */}
          <div style={{ position: "absolute", width: '25%', top: "50px", left: "20%", right: "66%", height: "2px", borderTop: "2px dashed rgba(176, 66, 255, 0.5)", zIndex: 0 }}>
            <div style={{ position: "absolute", right: "-10px", top: "-11px", color: "rgba(176, 66, 255, 0.5)", fontSize: "14px" }}>▶</div>
          </div>
          {/* Dashed line 2 */}
          <div style={{ position: "absolute", width: '25%', top: "50px", left: "53%", right: "33%", height: "2px", borderTop: "2px dashed rgba(236, 72, 153, 0.5)", zIndex: 0 }}>
            <div style={{ position: "absolute", right: "-10px", top: "-11px", color: "rgba(236, 72, 153, 0.5)", fontSize: "14px" }}>▶</div>
          </div>

          <motion.div 
            className="howto-step"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.3 }}
            variants={itemVariants}
          >
            <div className="howto-icon-wrapper">
              <ImUpload2 />
            </div>
            <div className="howto-number">01</div>
            <p>
              Just upload your artwork, tracks, and release info with just a
              few clicks easily. Choose 100+ streaming services including
              Amazon, Spotify, iTunes, and more
            </p>
          </motion.div>

          <motion.div 
            className="howto-step"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.5 }}
            variants={itemVariants}
          >
            <div className="howto-icon-wrapper">
              <TiSocialYoutubeCircular />
            </div>
            <div className="howto-number">02</div>
            <p>
              FTtunes will quickly release your masterpiece to stores and
              streaming services worldwide. Start selling your music online
              now to get your music heard by millions.
            </p>
          </motion.div>

          <motion.div 
            className="howto-step"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.7 }}
            variants={itemVariants}
          >
            <div className="howto-icon-wrapper">
              <FaWallet />
            </div>
            <div className="howto-number">03</div>
            <p>
              Earn money by doing what you love. Sell your music online and
              you get paid every time your music is played or downloaded
              worldwide.
            </p>
          </motion.div>
        </div>
      </Container>
    </div>
  );
};

export default HowTo;
